module.exports = __webpack_public_path__ + "static/media/activities.bf338103.jpg";